export default function (element, data) {
    element.querySelector('.video__link').addEventListener('click', async function(e) {
        // e.preventDefault();
        let imageBlock = element.querySelector('.media__block_image');
        let btnElement = element.querySelector('.video__link');
        let videoBlock = element.querySelector('.video__block');
        let btnElementBorder = element.querySelector('.video__link_border');

        let videoLink = videoBlock.dataset.videoBlock;

        videoBlock.innerHTML = `
            <iframe width="850" height="480"
                src="${videoLink}?autoplay=1"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen>
            </iframe>`;
        
        videoBlock.classList.remove('hidden');
        // imageBlock.classList.add('hidden');
        btnElement.classList.add('hidden');
        btnElementBorder.classList.add('hidden');
    });

}